import * as Blockly from 'blockly/core';
import 'blockly/python';
import createCustomThresholdFields from "./strata_custom_threshold_fields";
import {getAllowedOutputs} from "./strata_compatibility_checks";
import createInfoButton from './strata_additional_info'

Blockly.Blocks['strata_conflict_indicator'] = {
    init: function () {
        let indicatorInput = this.appendDummyInput()
            .setAlign(Blockly.ALIGN_LEFT)
            .appendField("Security Indicator  ")
            .appendField(new Blockly.FieldDropdown([
                ["Battles", "conflict_battles"],
                ["Explosions/remote violence", "conflict_recent_explosions"],
                ["Violence against civilians", "conflict_recent_violence"],
                ["Protests", "conflict_recent_protests"],
                ["Riots", "conflict_recent_riots"],
                // ["Recent Internal Conflict", "rec_int_cnf"],
                // ["Years Since Violent Conflict", "yrs_vcnf"],
                // ["Resolution Efforts", "res_eff"],
                // ["Politically Relevant Ethnic Groups", "eth_grp"],
                // ["Ethnic Relationship to Rebel Group", "reb_grp"]
              ]), "indicator_selection");

        createInfoButton(indicatorInput, this)
        createCustomThresholdFields(this);

        this.setPreviousStatement(true, 'strata_conflict_indicator')
        this.setNextStatement(true, getAllowedOutputs('conflict_indicators'));
      this.setStyle('conflict_indicator')
      this.setTooltip("");
      this.setHelpUrl("");
    }
}